import { Download, Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface QRExportActionsProps {
  onDownloadPNG: () => void;
  onDownloadSVG: () => void;
  onSaveToLibrary: () => void | Promise<void>;
  showSaveToLibrary: boolean;
  isSaving?: boolean;
}

export function QRExportActions({
  onDownloadPNG,
  onDownloadSVG,
  onSaveToLibrary,
  showSaveToLibrary,
  isSaving,
}: QRExportActionsProps) {
  return (
    <div className="flex items-center gap-2 flex-wrap justify-center">
      <button
        type="button"
        onClick={onDownloadPNG}
        className="flex items-center gap-1.5 h-9 px-4 rounded-md bg-white/5 text-xs font-semibold text-[var(--text-secondary)] hover:text-[var(--text-main)] hover:bg-white/10 transition-colors border border-white/5"
      >
        <Download size={13} />
        PNG
      </button>
      <button
        type="button"
        onClick={onDownloadSVG}
        className="flex items-center gap-1.5 h-9 px-4 rounded-md bg-white/5 text-xs font-semibold text-[var(--text-secondary)] hover:text-[var(--text-main)] hover:bg-white/10 transition-colors border border-white/5"
      >
        <Download size={13} />
        SVG
      </button>
      {showSaveToLibrary && (
        <button
          type="button"
          onClick={() => void onSaveToLibrary()}
          disabled={isSaving}
          className={cn(
            'flex items-center gap-1.5 h-9 px-4 rounded-md text-xs font-semibold transition-colors border',
            isSaving
              ? 'bg-white/5 text-[var(--text-secondary)] border-white/5 cursor-not-allowed'
              : 'bg-brand/10 text-brand border-brand/20 hover:bg-brand/20'
          )}
        >
          {isSaving ? <Loader2 size={13} className="animate-spin" /> : <Download size={13} />}
          Save to Library
        </button>
      )}
    </div>
  );
}
